module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionWlcjMobile.0eaae678.png";